import styles from "../AscChart.module.scss";

export interface TooltipData {
  top: number;
  left: number;
  columnWidth: number;
  columnLeft: number;
  averageCompletion: string;
  averageGrade: string;
}

interface IToolTip {
  data: TooltipData;

}

export const AscCustomTooltip = ({ data }: IToolTip) => {

  return (
    <>
      <div
        className={styles.tooltip}
        style={{
          top: data.top - 15,
          left: data.left,
        }}
      >
        <div className={styles.tooltipItem}>
          Average completion:{" "}
          <span className={styles.tooltipValue}>{data?.averageCompletion}%</span>
        </div>
        <div className={styles.tooltipItem}>
          Average grade:{" "}
          <span className={styles.tooltipValueSecond}>{data?.averageGrade}%</span>
        </div>
      </div>
      <div
        style={{
          left: data?.columnLeft,

          width: data?.columnWidth,
        }}
        className={styles.column}
      ></div>
    </>
  );
};
